import { createStore } from 'vuex'
import AES from '@/libs/AES'
import sendRequest from '@/libs/sendRequest'
import router from '@/router'

import { advisers } from './modules/advisers';
import { families } from './modules/families';
import { categories } from './modules/categories';
import { clients } from './modules/clients';
import { operations } from './modules/operations';
import { products } from './modules/products';
import { registries } from './modules/registries';
import { notifications } from './modules/notifications';
import { reports } from './modules/reports';
import { shipments_cost } from './modules/shipmentsCost';
import { banners } from './modules/banners';
import { points_category} from "@/store/modules/pointsCategories";
import { points_product} from "@/store/modules/pointsProducts";
import { points_settings } from "@/store/modules/pointsSettings";
import { points_operations } from "@/store/modules/pointsOperations";
import { levels } from "@/store/modules/levels";

// Heishop
import heishop from '@/store/modules/heishop/index'

// Supervision
import supervision from '@/store/modules/supervision/index'


import CONFIG from '../../src/page.config'

export default createStore({
	state: {
		alert: {
            open: false,
            message: 'Error',
            variant: 'danger',
            color_text: 'white',
            timeout: null,
        },
        loading: {
            show: false,
            title: 'Cargando',
            subtitle: 'Espere un momento...'
        },
		state: null
	},
	getters: {
		getLoading: (state) => state.loading,
		getAlert: (state) => state.alert,
		getSection: (state) => state.section,
		getSession: (state) => {
			let session = JSON.parse(sessionStorage.getItem('wiks@session')) || null
			state.session = session;
			return state.session
		},
		getHeaders (state) {
			const session = JSON.parse(sessionStorage.getItem('wiks@session')) || null
			return {
			  ...CONFIG.server[CONFIG.env].headers,
			  session: session?.token_session || null
			}
		}
	},
	mutations: {
		setLoading: (state, new_load) => {
            state.loading.show = new_load.show
            state.loading.title = (new_load.title !== undefined && new_load.title !== null) ? new_load.title : 'Cargando'
            state.loading.subtitle = (new_load.subtitle !== undefined && new_load.subtitle !== null) ? new_load.subtitle : 'Espere un momento...'
            state.loading.timeout = (new_load.timeout !== undefined && new_load.timeout !== null) ? new_load.timeout : null

            if(state.loading.timeout !== null) {
                setTimeout(() => {
                    state.loading.show = false
                }, state.loading.timeout)
            }
        },
		setAlert: (state, new_alert) => {
			state.alert.open = new_alert.open
			state.alert.message = (new_alert.message !== undefined) ? new_alert.message : ''
			state.alert.variant = (new_alert.variant !== undefined) ? new_alert.variant : 'success'
			state.alert.text_color = (new_alert.text_color !== undefined) ? new_alert.text_color : 'white'
			state.alert.timeout = (new_alert.timeout !== undefined) ? new_alert.timeout : 3000

			if (state.alert.timeout !== null) {
				setTimeout(() => {
					state.alert.open = false
				}, state.alert.timeout)
			}
		},
		setSection: (state, payload) => (state.section = payload),
		setSession: (state, payload) => {
			let encrypt = AES.encrypt(JSON.stringify(payload))
			console.group(encrypt)
			state.session = payload
			sessionStorage.setItem('wiks@session', JSON.stringify(payload))
			sessionStorage.setItem('encrypted', encrypt)
		}
	},
	actions: {
		// Loading
        showLoading: ({commit}) => {
            commit('setLoading', { show: true })
        },
        hiddenLoading: ({commit}) => {
            commit('setLoading', { show: false })
        },
        lostConection: ({commit}) => {
            commit('setLoading', { 
                show: true,
                title: 'Oops...',
                subtitle: 'No pudimos realizar la acción, espera un momento e intentalo nuevamente'
            })
        },
        // Alert
        showAlert: ({commit}, message) => {
            commit('setAlert', {
                open: true,
                message
            })
        },
        showWarning: ({commit}, message) => {
            commit('setAlert', {
                open: true,
                message,
                variant: 'warning'
            })
        },
        showError: ({commit}, message) => {
            commit('setAlert', {
                open: true,
                message,
                variant: 'danger'
            })
        },
        // Other
		login: async ({ commit, dispatch}, body) => {
			let response = await sendRequest('administrator/registries/login', 'POST', null, body, null)

			if(response.success && response.data.registro_datos) {
				commit('setSession', response.data.registro_datos)
				dispatch('showAlert', 'Bienvenido')
				router.push({ name: 'sales'})
			}
			else {
				commit('setAlert', { open: true, variant: 'danger', message: 'Usuario o Contraseña incorrectos'})
			}
		}
	},
	modules: {
		advisers,
		families,
		categories,
		clients,
		operations,
		products,
		registries,
		notifications,
		reports,
		shipments_cost,
		banners,
        points_category,
        points_product,
        points_settings,
        points_operations,
        levels,

		heishop,
		supervision,
	}
})
